// Custom Remote validator that allows adding custom messages from the response of a previous remote validator
window.Parsley.addAsyncValidator('remote-message', /** @this {Parsley} */ function(xhr) {
	if (xhr.responseJSON) {
		if (xhr.responseJSON.message) {
			this.options.remoteMessage = xhr.responseJSON.message;
		}
		if ('ok' in xhr.responseJSON) {
			return Boolean(xhr.responseJSON.ok);
		}
	}
	return xhr.status >= 200 && xhr.status < 300;
});

export {};